/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Record_DurationInputs */

const en_us2_exercise_sheet_record_duration = /** @type {(inputs: Exercise_Sheet_Record_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Longest hold`)
};

const pt_br2_exercise_sheet_record_duration = /** @type {(inputs: Exercise_Sheet_Record_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maior tempo`)
};

const es_419_exercise_sheet_record_duration = /** @type {(inputs: Exercise_Sheet_Record_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mayor tiempo`)
};

const pt_pt2_exercise_sheet_record_duration = /** @type {(inputs: Exercise_Sheet_Record_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maior tempo`)
};

const fr_fr2_exercise_sheet_record_duration = /** @type {(inputs: Exercise_Sheet_Record_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus long maintien`)
};

const de_de2_exercise_sheet_record_duration = /** @type {(inputs: Exercise_Sheet_Record_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Längstes Halten`)
};

const it_it2_exercise_sheet_record_duration = /** @type {(inputs: Exercise_Sheet_Record_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tenuta più lunga`)
};

/**
* | output |
* | --- |
* | "Longest hold" |
*
* @param {Exercise_Sheet_Record_DurationInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_record_duration = /** @type {((inputs?: Exercise_Sheet_Record_DurationInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Record_DurationInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_record_duration(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_record_duration(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_record_duration(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_record_duration(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_record_duration(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_record_duration(inputs)
	return en_us2_exercise_sheet_record_duration(inputs)
});
export { exercise_sheet_record_duration as "exercise-sheet.record_duration" }